
import { Vue, Component, Prop } from 'vue-property-decorator';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import UTILService from '@/services/utils.service';

@Component
export default class IDcardModal extends Vue {
  visible = false;

  labelCol = { span: 8 };

  wrapperCol = { span: 10 };


  @lazyInject(ShopService)
  shopService!: ShopService;

  @lazyInject(UTILService)
  private utilService!: UTILService;

  form: any = {
    id_number: '',
    name: '',
    shop_id: '',
    poi: '',
  };

  @Prop()
  detail!: any;

  @Prop()
  labelId!: string;

  async init() {
    this.visible = true;
    const { shop_id, poi, name } = JSON.parse(JSON.stringify(this.detail));
    this.form = {
      shop_id,
      id_number: '',
      name,
      poi,
      label_id: this.labelId,
    };
  }

  handleCancel() {
    this.visible = false;
  }

  async handleOk() {
    console.log(this.form);
    const res = await this.shopService.postUpdateIdCard(this.form);
    if (res) {
      this.$message.success('操作成功');
      this.visible = false;
      this.$emit('refresh');
    }
  }
}
